var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid',{class:[_vm.name, { video: _vm.video }],style:(_vm.mainCssVars),attrs:{"html-tag":"figure","layout":[
    {
      size: 1,
      columns: 'repeat(12, 1fr)',
      rows: 'repeat(1, auto)',
      gap: '6px',
    },
    {
      size: 2,
      columns: 'repeat(24, 1fr)',
      rows: 'repeat(1, auto)',
      gap: '10px',
    },
  ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__media`],attrs:{"layout":[
      { size: 1, x: 1, width: 12, y: 1, height: 1 },
      { size: 3, x: 1, width: 24, y: 1, height: 1 },
    ]}},[_c('transition',{attrs:{"name":"fade"}},[_c('m-media',{attrs:{"cms":_vm.cms,"layout":[
          { size: 0, bound: 667, ratio: [375, 667] },
          { size: 1, bound: 768, ratio: [1480, 833] },
          { size: 2, bound: 992, ratio: [1480, 833] },
          { size: 3, bound: 1200, ratio: [1480, 833] },
          { size: 4, bound: 1440, ratio: [1480, 833] },
        ]},on:{"has-video":_vm.hasVideo}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }